module.exports = __webpack_public_path__ + "img/society-queen-nanny-avatar.19fd450e.png";